import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top_bar" }
const _hoisted_2 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, { to: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            class: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back(-1)))
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("返回")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: '/' }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { class: "back" }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("主页")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"zhanwei2\" data-v-28d7d0b8></div><div class=\"game\" data-v-28d7d0b8><div class=\"game_left\" data-v-28d7d0b8><img src=\"https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493\" alt=\"\" data-v-28d7d0b8></div><div class=\"game_center\" data-v-28d7d0b8><p data-v-28d7d0b8>我的新游戏</p><p data-v-28d7d0b8>建立于2024-06-05 15:11:33</p><p data-v-28d7d0b8>导览编号23118</p><p data-v-28d7d0b8>繁体中文 不限地区─ 任何地点</p><p data-v-28d7d0b8>我建立了一个新游戏，快来玩玩看我做的游戏！</p></div><div class=\"game_right\" data-v-28d7d0b8><p data-v-28d7d0b8>更新时间2024-06-08 14:39:23</p><p data-v-28d7d0b8>编辑</p><p data-v-28d7d0b8>删除</p></div></div><div class=\"game\" data-v-28d7d0b8><div class=\"game_left\" data-v-28d7d0b8><img src=\"https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493\" alt=\"\" data-v-28d7d0b8></div><div class=\"game_center\" data-v-28d7d0b8><p data-v-28d7d0b8>我的新游戏</p><p data-v-28d7d0b8>建立于2024-06-05 15:11:33</p><p data-v-28d7d0b8>导览编号23118</p><p data-v-28d7d0b8>繁体中文 不限地区─ 任何地点</p><p data-v-28d7d0b8>我建立了一个新游戏，快来玩玩看我做的游戏！</p></div><div class=\"game_right\" data-v-28d7d0b8><p data-v-28d7d0b8>更新时间2024-06-08 14:39:23</p><p data-v-28d7d0b8>编辑</p><p data-v-28d7d0b8>删除</p></div></div><div class=\"game\" data-v-28d7d0b8><div class=\"game_left\" data-v-28d7d0b8><img src=\"https://s3-ap-northeast-1.amazonaws.com/popworld-tourguide-storage2/images/game_default_cover.png?1717571493\" alt=\"\" data-v-28d7d0b8></div><div class=\"game_center\" data-v-28d7d0b8><p data-v-28d7d0b8>我的新游戏</p><p data-v-28d7d0b8>建立于2024-06-05 15:11:33</p><p data-v-28d7d0b8>导览编号23118</p><p data-v-28d7d0b8>繁体中文 不限地区─ 任何地点</p><p data-v-28d7d0b8>我建立了一个新游戏，快来玩玩看我做的游戏！</p></div><div class=\"game_right\" data-v-28d7d0b8><p data-v-28d7d0b8>更新时间2024-06-08 14:39:23</p><p data-v-28d7d0b8>编辑</p><p data-v-28d7d0b8>删除</p></div></div><div class=\"zhanwei3\" data-v-28d7d0b8></div>", 5)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: 1000
      })
    ])
  ], 64))
}